"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var switch_1 = require("./switch");

exports.Input = styled_components_1.default.input.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['sizeOption'].includes(prop);
  }
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n\n  &:checked + ", "::before {\n    background-color: ", ";\n  }\n\n  &:checked + ", "::after {\n    transform: ", ";\n  }\n"], ["\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n\n  &:checked + ", "::before {\n    background-color: ", ";\n  }\n\n  &:checked + ", "::after {\n    transform: ", ";\n  }\n"])), switch_1.Switch, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
}, switch_1.Switch, function (_a) {
  var sizeOption = _a.sizeOption;
  return sizeOption === 'small' ? 'translate(calc(1.5rem - 100%), -50%)' : 'translate(calc(2.3rem - 100%), -50%)';
});
var templateObject_1;